<template>
  <div class="tab_content">
    <div class="title">
      <p class="tab_title">出让方概况</p>
    </div>

    <div class="tab_form">
      <el-form ref="form" :rules="formRules" :model="form" label-width="160px">

        <!-- 国家地区 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="国家/地区">
              <el-input v-model="form.gjdq" placeholder="请输入，如：中国" />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 主体类型选择 -->
        <el-form-item label="主体类型" prop="srvalue">
          <el-radio-group v-model="srvalue" @change="oneChange">
            <el-radio label="国资">国有企事业单位</el-radio>
            <el-radio label="非国资">非国有企业</el-radio>
            <el-radio label="自然人">自然人</el-radio>
          </el-radio-group>
          <el-button type="text" @click="toShouquan" style="margin-left: 16px">去认证</el-button>
        </el-form-item>

        <!-- 企业：从认证列表选择 -->
        <div v-show="srvalue === '国资' || srvalue === '非国资'">
          <el-form-item label="单位名称">
            <el-select v-model="srvalue3" placeholder="请选择已认证的单位" @change="twoChange" style="width:300px">
              <el-option
                v-for="(item, index) in options2"
                :key="index"
                :label="item.dwmc"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="统一社会信用代码">
                <el-input v-model="form.tyshxydm" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="法定代表人">
                <el-input v-model="form.fddbr" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="注册地址">
                <el-input v-model="form.zcdzxx" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="注册资本">
                <el-input v-model="form.zczb" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="联系人姓名">
                <el-input v-model="form.lxrxm" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定电话">
                <el-input v-model="form.gddh" disabled />
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="邮政编码">
                <el-input v-model="form.yzbm" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="职务/职称">
                <el-input v-model="form.zwzc" placeholder="请输入" />
              </el-form-item>
            </el-col>
          </el-row>

          <el-form-item label="地址、电话">
            <el-input v-model="form.dzdh" placeholder="请输入" />
          </el-form-item>

          <el-form-item label="决议类型">
            <el-radio-group v-model="form.jylx">
              <el-radio label="董事会决议">董事会决议</el-radio>
              <el-radio label="总经理办公会决议">总经理办公会决议</el-radio>
              <el-radio label="其他">其他</el-radio>
            </el-radio-group>
            <el-input
              v-show="form.jylx === '其他'"
              v-model="form.jylxqt"
              style="margin-top: 8px; width: 300px"
              placeholder="请输入决议类型说明"
            />
          </el-form-item>
        </div>

        <!-- 个人 -->
        <div v-show="srvalue === '自然人'">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="姓名" prop="xm">
                <el-input v-model="form.xm" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="移动电话" prop="yddh">
                <el-input v-model="form.yddh" disabled />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="证件号码" prop="zjhm">
                <el-input v-model="form.zjhm" disabled />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="称谓" prop="cw">
                <el-input v-model="form.cw" placeholder="请输入，如：先生/女士" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="固定电话">
                <el-input v-model="form.gddh" placeholder="选填" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="电子邮箱">
                <el-input v-model="form.dzyx" placeholder="选填" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="通讯地址">
            <el-cascader
              :value="addressCascader"
              :options="regionOptions"
              :props="{ expandTrigger: 'hover' }"
              clearable
              placeholder="请选择省/市/区（选填）"
              style="width: 100%"
              @change="onAddressChange"
            />
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input v-model="form.txdzxx" placeholder="选填" />
          </el-form-item>
          <el-form-item label="其他信息">
            <el-input v-model="form.qtxx" type="textarea" :rows="2" placeholder="选填" />
          </el-form-item>
        </div>

        <!-- 受托机构 -->
        <div class="sub-section">
          <el-form-item label="是否有受托机构">
            <el-radio-group v-model="form.sfstjg">
              <el-radio label="是">是</el-radio>
              <el-radio label="否">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.sfstjg === '是'">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="受托机构名称">
                  <el-input v-model="form.stjgDwmc" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="统一社会信用代码">
                  <el-input v-model="form.stjgTyshxydm" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="联系人姓名">
                  <el-input v-model="form.stjgLxrxm" placeholder="请输入" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="移动电话">
                  <el-input v-model="form.stjgYddh" placeholder="请输入" />
                </el-form-item>
              </el-col>
            </el-row>
          </template>
        </div>

        <div class="button flex-center">
          <el-button type="primary" @click="doStaging('form')">暂存</el-button>
          <el-button type="primary" @click="doSubmit('form')">下一步</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { getRequest } from "../../../api/api";
import { options as regionOptions } from "../../../api/region";

function createEmptyForm() {
  return {
    gjdq: "中国",
    dwmc: "",
    tyshxydm: "",
    fddbr: "",
    zczb: "",
    zcdzxx: "",
    dzdh: "",
    lxrxm: "",
    gddh: "",
    yzbm: "",
    zwzc: "",
    jylx: "",
    jylxqt: "",
    sfstjg: "否",
    stjgDwmc: "",
    stjgTyshxydm: "",
    stjgLxrxm: "",
    stjgYddh: "",
    xm: "",
    yddh: "",
    zjhm: "",
    cw: "",
    dzyx: "",
    txdzsf: "",
    txdzcs: "",
    txdzxq: "",
    txdzxx: "",
    qtxx: "",
  };
}

export default {
  props: ["id", "cfrom"],
  data() {
    return {
      srvalue: "国资",
      srvalue3: null,
      options2: [],
      nonNationEnterprises: [],
      nationEnterprises: [],
      realnameAuthPO: null,
      regionOptions,
      form: createEmptyForm(),
    };
  },
  computed: {
    addressCascader() {
      return [this.form.txdzsf, this.form.txdzcs, this.form.txdzxq].filter(Boolean);
    },
    formRules() {
      if (this.srvalue !== "自然人") return {};
      return {
        xm: [{ required: true, message: "请先完成个人认证", trigger: "change" }],
        yddh: [{ required: true, message: "请先完成个人认证", trigger: "change" }],
        zjhm: [{ required: true, message: "请先完成个人认证", trigger: "change" }],
        cw: [{ required: true, message: "请输入称谓", trigger: "blur" }],
      };
    },
  },
  methods: {
    normalizeRegisteredCapital(value) {
      if (value == null || value === "") return "";
      const raw = String(value).trim().replace(/,/g, "");
      if (!raw) return "";
      const match = raw.match(/-?\d+(?:\.\d+)?/);
      if (!match) return "";
      let num = parseFloat(match[0]);
      if (Number.isNaN(num)) return "";
      // 带“万”时按万元换算为元
      if (raw.includes("万")) {
        num = num * 10000;
      }
      return String(num);
    },
    createEmptyForm,
    onAddressChange(val) {
      this.form.txdzsf = (val && val[0]) || "";
      this.form.txdzcs = (val && val[1]) || "";
      this.form.txdzxq = (val && val[2]) || "";
    },
    oneChange() {
      const { gjdq, sfstjg } = this.form;
      this.form = {
        ...createEmptyForm(),
        gjdq,
        sfstjg,
      };
      this.srvalue3 = null;
      if (this.srvalue === "国资") {
        this.options2 = this.nationEnterprises;
      } else if (this.srvalue === "非国资") {
        this.options2 = this.nonNationEnterprises;
      } else if (this.srvalue === "自然人") {
        this.fillFromAuthPerson();
      }
    },
    fillFromAuthPerson() {
      const mapped = this.mapAuthPerson(this.realnameAuthPO);
      this.form = {
        ...this.form,
        ...mapped,
      };
    },
    mapAuthPerson(po) {
      if (!po || typeof po !== "object") return {};
      return {
        xm: po.xm || po.name || "",
        yddh: po.yddh || po.phone || "",
        zjhm: po.zjhm || po.idcardNumber || "",
        cw: po.cw || "",
        gddh: po.gddh || "",
        dzyx: po.dzyx || po.email || "",
        txdzsf: po.txdzsf || "",
        txdzcs: po.txdzcs || "",
        txdzxq: po.txdzxq || "",
        txdzxx: po.txdzxx || po.actualAddress || "",
        qtxx: po.qtxx || "",
      };
    },
    twoChange(id) {
      const item = this.options2.find((o) => o.id === id);
      if (item) {
        this.form = {
          ...this.form,
          dwmc: item.dwmc || "",
          tyshxydm: item.tyshxydm || "",
          fddbr: item.fddbr || "",
          zczb: this.normalizeRegisteredCapital(item.zczb),
          zcdzxx: item.zcdzxx || "",
          dzdh: item.dzdh || "",
          lxrxm: item.lxrxm || "",
          gddh: item.gddh || "",
          yzbm: item.yzbm || "",
        };
      }
    },
    mapEnterpriseItem(item) {
      return {
        ...item,
        dwmc: item.name || item.dwmc || "",
        tyshxydm: item.code || item.tyshxydm || "",
        fddbr: item.legalPerson || item.fddbr || "",
        zczb: this.normalizeRegisteredCapital(item.registeredCapital || item.zczb),
        zcdzxx: item.zcdzxx || item.domicile || item.registeredAddress || "",
        dzdh: item.dzdh || "",
        lxrxm: item.contactPerson || item.lxrxm || "",
        gddh: item.contactPhone || item.gddh || "",
        yzbm: item.yzbm || "",
      };
    },
    findEnterpriseId(info) {
      if (!info) return null;
      const list = this.options2 || [];
      const code = info.tyshxydm || info.code || "";
      const name = info.dwmc || info.name || "";

      if (code) {
        const byCode = list.find(
          (item) => item.tyshxydm === code || item.code === code
        );
        if (byCode) return byCode.id;
      }

      if (name) {
        const byName = list.find(
          (item) => item.dwmc === name || item.name === name
        );
        if (byName) return byName.id;
      }

      return null;
    },
    normalizeTransferorInfo(info) {
      if (!info || typeof info !== "object") return null;
      return {
        gjdq: info.gjdq || "中国",
        dwmc: info.dwmc || info.name || "",
        tyshxydm: info.tyshxydm || info.code || "",
        fddbr: info.fddbr || info.legalPerson || "",
        zczb: this.normalizeRegisteredCapital(
          info.zczb || info.registeredCapital
        ),
        zcdzxx:
          info.zcdzxx || info.registeredAddress || info.domicile || info.zcdz || "",
        dzdh: info.dzdh || "",
        lxrxm: info.lxrxm || info.contactPerson || "",
        gddh: info.gddh || info.contactPhone || "",
        yzbm: info.yzbm || "",
        zwzc: info.zwzc || "",
        jylx: info.jylx || "",
        jylxqt: info.jylxqt || "",
        sfstjg: info.sfstjg || "否",
        stjgDwmc: info.stjgDwmc || "",
        stjgTyshxydm: info.stjgTyshxydm || "",
        stjgLxrxm: info.stjgLxrxm || "",
        stjgYddh: info.stjgYddh || "",
        xm: info.xm || info.name || "",
        yddh: info.yddh || info.phone || "",
        zjhm: info.zjhm || info.idcardNumber || "",
        cw: info.cw || "",
        dzyx: info.dzyx || info.email || "",
        txdzsf: info.txdzsf || "",
        txdzcs: info.txdzcs || "",
        txdzxq: info.txdzxq || "",
        txdzxx: info.txdzxx || info.actualAddress || "",
        qtxx: info.qtxx || "",
        ztlx: info.ztlx || "",
        applicantType: info.applicantType,
      };
    },
    resolveSubjectType(info) {
      if (info.ztlx === "自然人" || info.applicantType === "自然人") {
        return "自然人";
      }
      if (
        info.ztlx === "非国有企业" ||
        info.ztlx === "非国资" ||
        info.applicantType === "非国资"
      ) {
        return "非国资";
      }
      return "国资";
    },
    mapZtlx(srvalue) {
      if (srvalue === "自然人") return "自然人";
      if (srvalue === "非国资") return "非国有企业";
      return "国有企事业单位";
    },
    restoreFromCfrom() {
      if (!this.cfrom) return;
      let info = null;
      if (this.cfrom.transferorInfos && this.cfrom.transferorInfos.length > 0) {
        info = this.cfrom.transferorInfos[0];
      } else if (this.cfrom.crfInfos && this.cfrom.crfInfos.length > 0) {
        info = this.cfrom.crfInfos.find((i) => i.type == 1 || i.type === "1");
      }
      if (!info) return;

      const normalized = this.normalizeTransferorInfo(info);
      this.srvalue = this.resolveSubjectType(normalized);
      this.form = {
        ...createEmptyForm(),
        gjdq: normalized.gjdq,
        dwmc: normalized.dwmc,
        tyshxydm: normalized.tyshxydm,
        fddbr: normalized.fddbr,
        zczb: normalized.zczb,
        zcdzxx: normalized.zcdzxx,
        dzdh: normalized.dzdh,
        lxrxm: normalized.lxrxm,
        gddh: normalized.gddh,
        yzbm: normalized.yzbm,
        zwzc: normalized.zwzc,
        jylx: normalized.jylx,
        jylxqt: normalized.jylxqt,
        sfstjg: normalized.sfstjg,
        stjgDwmc: normalized.stjgDwmc,
        stjgTyshxydm: normalized.stjgTyshxydm,
        stjgLxrxm: normalized.stjgLxrxm,
        stjgYddh: normalized.stjgYddh,
        xm: normalized.xm,
        yddh: normalized.yddh,
        zjhm: normalized.zjhm,
        cw: normalized.cw,
        dzyx: normalized.dzyx,
        txdzsf: normalized.txdzsf,
        txdzcs: normalized.txdzcs,
        txdzxq: normalized.txdzxq,
        txdzxx: normalized.txdzxx,
        qtxx: normalized.qtxx,
      };

      if (this.srvalue === "自然人") {
        if (!this.form.xm || !this.form.yddh || !this.form.zjhm) {
          this.fillFromAuthPerson();
        }
        this.srvalue3 = null;
        return;
      }

      const baseOptions =
        this.srvalue === "国资" ? this.nationEnterprises : this.nonNationEnterprises;
      this.options2 = [...(baseOptions || [])];

      let matchedId = this.findEnterpriseId(normalized);
      if (matchedId == null && normalized.dwmc) {
        const tempId = `__saved__${normalized.tyshxydm || normalized.dwmc}`;
        this.options2 = [
          {
            id: tempId,
            dwmc: normalized.dwmc,
            tyshxydm: normalized.tyshxydm,
            fddbr: normalized.fddbr,
            zczb: normalized.zczb,
            zcdzxx: normalized.zcdzxx,
            dzdh: normalized.dzdh,
            lxrxm: normalized.lxrxm,
            gddh: normalized.gddh,
            yzbm: normalized.yzbm,
          },
          ...this.options2,
        ];
        matchedId = tempId;
      }
      this.srvalue3 = matchedId;
    },
    getData() {
      getRequest({ url: "/api/v1/transfer/transferMessage" }).then((res) => {
        if (res.errcode == 200) {
          this.nonNationEnterprises = (res.data.nonNationEnterprises || []).map(
            (item) => this.mapEnterpriseItem(item)
          );
          this.nationEnterprises = (res.data.nationEnterprises || []).map((item) =>
            this.mapEnterpriseItem(item)
          );
          this.realnameAuthPO = res.data.realnameAuthPO || null;
          if (!this.cfrom || (!this.cfrom.transferorInfos && !this.cfrom.crfInfos)) {
            this.srvalue = "国资";
            this.options2 = this.nationEnterprises;
          } else {
            this.restoreFromCfrom();
          }
        } else {
          this.$message.error(res.errmsg);
        }
      });
    },
    buildValue() {
      const v = { ...this.form };
      v.ztlx = this.mapZtlx(this.srvalue);
      v.applicantType = this.srvalue;
      if (!v.jylx) {
        v.jylxqt = "";
      }
      const value = {
        transferorInfos: [v],
      };
      if (this.id) value.id = this.id;
      return value;
    },
    doStaging(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("aStagin", this.buildValue());
      });
    },
    doSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) this.$emit("aChange", "tab2", this.buildValue());
      });
    },
    toShouquan() {
      this.$router.push({ name: "my", params: { tab: "授权中心" } });
    },
  },
  watch: {
    cfrom: {
      deep: true,
      handler() {
        this.restoreFromCfrom();
      },
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<style lang="scss">
.tab_content {
  margin: 0 30px;

  .title {
    display: flex;
    .tab_title {
      font-size: 18px;
      font-weight: 500;
      margin-right: 12px;
    }
  }

  .el-input.is-disabled .el-input__inner {
    color: #555555;
  }

  .tab_form {
    margin-top: 20px;

    .sub-section {
      margin-top: 16px;
      padding-top: 16px;
      border-top: 1px dashed #e4e7ed;
    }

    .button {
      button {
        width: 160px;
        margin: 0 24px;
        display: block;
      }
    }
  }
}
</style>
